// extracted by mini-css-extract-plugin
module.exports = {"orderReviewsInvitation":"orderReviewsInvitation___3720x","isMobile":"isMobile___2tN82","settingDisable":"settingDisable___14yio"};